export default "__VITE_ASSET__D8NHI7le__"